const STORE_DATA = window.SSC_STORE_DATA;
const ZIP_DB = window.SSC_ZIP_DB;

const AMAZON_URL = "https://www.amazon.com/Brooke-Joy-Games-Creates-10-Minute/dp/B0H27N35LN/?maas=maas_adg_5B337326C2F60ECB30C26F484C252863_afap_abs&ref_=aa_maas&tag=maas";
const TARGET_PRODUCT_URL = "https://www.target.com/p/speed-swap-chaos/-/A-95028528";
const TARGET_LOGO_SRC = window.SSC_TARGET_LOGO_URL;
const AMAZON_LOGO_SRC = window.SSC_AMAZON_LOGO_URL;

function googleDirectionsUrl(store){
  const q = encodeURIComponent(`${store.a1}, ${store.city}, ${store.state} ${store.zip}`);
  return "https://www.google.com/maps/dir/?api=1&destination=" + q;
}

// ============================================================
// Map setup — OpenStreetMap tiles, free and keyless (CARTO's raster
// basemaps started requiring a key + watermarking unauthenticated
// requests in Aug 2026).
// ============================================================
const map = L.map('map', { zoomControl:false, attributionControl:true }).setView([39.5, -98.35], 4);
L.control.zoom({ position:'bottomright' }).addTo(map);
L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  subdomains: 'abc',
  maxZoom: 19
}).addTo(map);

function pinDivIcon(selected){
  return L.divIcon({
    className: '',
    html: `<div class="pin${selected ? ' selected' : ''}"></div>`,
    iconSize: selected ? [34,34] : [26,26],
    iconAnchor: selected ? [17,32] : [13,25]
  });
}
const userDivIcon = L.divIcon({
  className: '',
  html: `<div class="user-pulse"></div>`,
  iconSize:[18,18],
  iconAnchor:[9,9]
});

// A handful of stores share a zip code (and therefore the exact same geocoded
// point) with another store. This nudges each one a short, fixed distance
// apart just for the MAP POSITION — nearest-store distances still use the
// real lat/lng, so ranking and the "X mi" shown to the user stay accurate.
(function fanOutOverlappingPins(){
  const groups = {};
  STORE_DATA.forEach((s, i) => {
    const key = s.lat.toFixed(4) + ',' + s.lng.toFixed(4);
    (groups[key] = groups[key] || []).push(i);
  });
  Object.values(groups).forEach(group => {
    if (group.length < 2){
      const s = STORE_DATA[group[0]];
      s.mapLat = s.lat; s.mapLng = s.lng;
      return;
    }
    const radius = 0.0025;
    group.forEach((idx, j) => {
      const angle = (2 * Math.PI * j) / group.length;
      const s = STORE_DATA[idx];
      s.mapLat = s.lat + radius * Math.cos(angle);
      s.mapLng = s.lng + radius * Math.sin(angle);
    });
  });
})();

const storeMarkers = STORE_DATA.map((store, i) => {
  const marker = L.marker([store.mapLat, store.mapLng], { icon: pinDivIcon(false) });
  marker.bindPopup(popupHtml(store));
  marker.on('click', () => selectStore(i, true));
  marker.addTo(map);
  return marker;
});

let userMarker = null;
let activeIndex = null;

function popupHtml(store){
  return `
    <div class="popup-tag">Target</div>
    <div class="popup-name">${escapeHtml(store.name)}${store.num ? ' #' + store.num : ''}</div>
    <div class="popup-addr">${escapeHtml(store.a1)}${store.a2 ? ', ' + escapeHtml(store.a2) : ''}<br>${escapeHtml(store.city)}, ${store.state} ${store.zip}</div>
  `;
}
function escapeHtml(s){
  return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
}

// ============================================================
// Distance + search
// ============================================================
function haversineMiles(lat1, lon1, lat2, lon2){
  const R = 3958.8;
  const toRad = d => d * Math.PI / 180;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a = Math.sin(dLat/2)**2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon/2)**2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
}

const zipInput = document.getElementById('zipInput');
const searchForm = document.getElementById('searchForm');
const searchError = document.getElementById('searchError');
const resultsList = document.getElementById('resultsList');
const resultCount = document.getElementById('resultCount');
const resultSub = document.getElementById('resultSub');
const locateBtn = document.getElementById('locateBtn');

const RESULT_LIMIT = 5;

searchForm.addEventListener('submit', (e) => {
  e.preventDefault();
  const zip = zipInput.value.trim();
  if (!/^\d{5}$/.test(zip)){
    searchError.textContent = 'Please enter a valid 5-digit zip code.';
    return;
  }
  searchError.textContent = '';
  lookupZip(zip);
});

locateBtn.addEventListener('click', () => {
  if (!navigator.geolocation){
    searchError.textContent = 'Location services are not available in this browser.';
    return;
  }
  searchError.textContent = 'Locating…';
  navigator.geolocation.getCurrentPosition(
    (pos) => {
      searchError.textContent = '';
      placeUser(pos.coords.latitude, pos.coords.longitude, 'your location');
    },
    () => { searchError.textContent = "Couldn't access your location — try a zip code instead."; }
  );
});

// Zip codes are resolved instantly from an embedded offline table (ZIP_DB) —
// no network request required, so this works even with no internet connection.
function lookupZip(zip){
  const coords = ZIP_DB[zip];
  if (!coords){
    searchError.textContent = "We couldn't find that zip code — please double check it.";
    return;
  }
  searchError.textContent = '';
  placeUser(coords[0], coords[1], `zip ${zip}`);
}

function placeUser(lat, lng, label){
  if (userMarker) map.removeLayer(userMarker);
  userMarker = L.marker([lat, lng], { icon: userDivIcon, zIndexOffset: 1000 }).addTo(map);
  userMarker.bindPopup(`<div class="popup-name">${escapeHtml(label)}</div>`);

  const ranked = STORE_DATA
    .map((store, i) => ({ ...store, i, dist: haversineMiles(lat, lng, store.lat, store.lng) }))
    .sort((a,b) => a.dist - b.dist)
    .slice(0, RESULT_LIMIT);

  renderResults(ranked, label);

  const bounds = L.latLngBounds([[lat,lng], [ranked[0].mapLat, ranked[0].mapLng]]);
  ranked.slice(0,3).forEach(s => bounds.extend([s.mapLat, s.mapLng]));
  map.flyToBounds(bounds, { padding:[70,70], maxZoom:11, duration:1.1 });

  activeIndex = null;
  storeMarkers.forEach((m) => m.setIcon(pinDivIcon(false)));
}

function renderResults(ranked, label){
  resultCount.textContent = ranked.length;
  resultSub.textContent = `Closest to ${label.charAt(0).toUpperCase() + label.slice(1)}`;
  resultsList.innerHTML = '';

  ranked.forEach(store => {
    const card = document.createElement('div');
    card.className = 'store-card';
    card.dataset.index = store.i;

    card.innerHTML = `
      <div class="store-top">
        <span class="store-name"><img class="target-icon" src="${TARGET_LOGO_SRC}" alt="Target">${escapeHtml(store.name)}${store.num ? ' #' + store.num : ''}</span>
        <span class="store-dist">${store.dist.toFixed(1)} mi</span>
      </div>
      <div class="store-addr">${escapeHtml(store.a1)}${store.a2 ? ', ' + escapeHtml(store.a2) : ''}<br>${escapeHtml(store.city)}, ${store.state} ${store.zip}</div>
      <div class="store-actions">
        <a class="btn-primary" href="${TARGET_PRODUCT_URL}" target="_blank" rel="noopener">Shop on Target.com</a>
        <a class="btn-ghost" href="${googleDirectionsUrl(store)}" target="_blank" rel="noopener">Directions</a>
      </div>
      <a class="store-amazon" href="${AMAZON_URL}" target="_blank" rel="noopener">Or shop this on Amazon.com →</a>
    `;
    card.addEventListener('click', (e) => {
      if (e.target.tagName === 'A') return;
      selectStore(store.i, true);
    });
    resultsList.appendChild(card);
  });
}

function selectStore(index, panTo){
  const store = STORE_DATA[index];
  if (activeIndex !== null && storeMarkers[activeIndex]){
    storeMarkers[activeIndex].setIcon(pinDivIcon(false));
  }
  activeIndex = index;
  storeMarkers[index].setIcon(pinDivIcon(true));

  document.querySelectorAll('.store-card').forEach(c => {
    c.classList.toggle('selected', Number(c.dataset.index) === index);
  });
  const activeCard = document.querySelector(`.store-card[data-index="${index}"]`);
  if (activeCard) activeCard.scrollIntoView({ behavior:'smooth', block:'nearest' });

  if (panTo){
    map.flyTo([store.mapLat, store.mapLng], Math.max(map.getZoom(), 12), { duration:0.7 });
    storeMarkers[index].openPopup();
  }
}

// Restrict zip input to digits
zipInput.addEventListener('input', () => {
  zipInput.value = zipInput.value.replace(/\D/g, '').slice(0,5);
});

// Self-test convenience: since the zip field ships prefilled, run that
// search automatically so the page shows real, working results on load.
if (/^\d{5}$/.test(zipInput.value.trim())){
  lookupZip(zipInput.value.trim());
}
